export const MuiButtonGroup = {
    defaultProps: {
        disableElevation: true,
        variant: 'contained',
        size: 'small'
    }
};

//# sourceMappingURL=button-group.js.map